import { createContext } from 'react';
import { DrawerScrollContextProps } from './types';

export const ScrollContext = createContext<DrawerScrollContextProps>({
  top: false,
  bottom: false,
});
